export default __webpack_public_path__ + "static/media/Icon-leftarrow.c428bb33.svg";